<template>
  <b-card
    v-if="isOnboardingRedesign"
    no-body
    :class="[
      selected ? 'tw-border-[#1A6A72]' : 'tw-border-gray-300',
      mini ? 'lg:tw-max-h-[400px]' : 'lg:tw-max-h-[500px]',
    ]"
    class="tw-rounded-2xl tw-border tw-overflow-hidden md:!tw-flex md:tw-flex-row tw-w-full lg:tw-max-h-[500px]"
  >
    <div
      class="tw-pt-4 tw-px-4 tw-m-4 tw-rounded-xl md:tw-w-1/2 lg:tw-w-[47%] tw-overflow-hidden md:tw-h-[250px] lg:tw-h-[300px] tw-flex tw-items-stretch"
      :class="{
        'tw-bg-[#EBF5F4]': ['C', 'D1'].includes(onboardingVariant),
        'tw-bg-[#DCD7EE]': !['C', 'D1'].includes(onboardingVariant),
      }"
    >
      <div class="tw-relative tw-w-full">
        <img
          class="tw-w-full tw-object-contain md:tw-object-cover md:tw-h-[218px] lg:tw-h-[268px]"
          :class="{ 'tw-cursor-pointer': !isAutoSelected, 'tw-cursor-default': isAutoSelected }"
          :src="
            product.image == null
              ? require('@/assets/images/dashboard/articlebg.png')
              : product.image
          "
          @click.prevent="!isAutoSelected && (selected = !selected)"
        >
        <div class="tw-flex tw-justify-between tw-items-center tw-absolute tw-top-0 tw-left-0 tw-right-0">
          <div
            v-if="!isAutoSelected"
            class="tw-flex tw-gap-1"
          >
            <CustomCheckbox
              v-if="showCustomCheckbox"
              v-model="selected"
            >
              {{ selected ? 'Selected' : 'Select' }}
            </CustomCheckbox>
            <template v-else>
              <b-form-checkbox
                :id="'checkbox-' + product.id"
                v-model="selected"
                name="product-id"
                class="product-reveal-checkbox"
                :value="true"
                :unchecked-value="false"
              />
              <p class="tw-mb-0 tw-mt-0.5">
                {{ selected ? 'Selected' : 'Select' }}
              </p>
            </template>
          </div>
  
          <span
            v-if="benefitTag"
            class="tw-border tw-font-atten-medium tw-rounded-full tw-py-[2px] tw-px-2 tw-text-[12px] tw-flex tw-items-center tw-justify-center"
            :class=" ['D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)
              ? 'tw-border-black'
              : '!tw-border-[#DDDEE2]'
            "
          >
            <img
              v-if="!['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
              src="@/assets/images/cro/fsa-icon.svg"
              alt="fsa-hsa-eligible"
              class="tw-size-[16px]"
            >
            <span class="tw-flex-1">
              {{ benefitTag }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="md:tw-w-1/2 lg:tw-w-[53%] md:tw-py-4 tw-overflow-y-auto">
      <div
        class="tw-px-6 md:tw-pl-0 md:tw-pr-4"
      >
        <h3 :class="mini ? 'tw-text-2xl tw-mb-1' : 'tw-text-xl lg:tw-text-2xl'">
          {{ product.name }}
        </h3>
        <!-- Product description -->
        <ul v-if="['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
          <li
            v-for="(description, i) in descriptionTextList"
            :key="`${i}-p-description`"
            class="tw-flex tw-items-start tw-gap-2 tw-text-lg tw-mb-0"
          >
            <img
              src="@/assets/images/svg/check-green.svg"
              alt="fsa-hsa-eligible"
              class="tw-h-[16px] tw-mt-[6px]"
            >
            {{ description }}
          </li>
        </ul>
        <template v-else>
          <p
            class="mb-0  tw-tracking-tight"
            :class="[
              mini
                ? 'tw-text-lg md:tw-text-base lg:tw-text-lg tw-leading-none'
                : 'tw-text-base lg:tw-text-lg',
              ['E1', 'F1', 'F2'].includes(onboardingVariant)
                ? 'tw-border-black'
                : 'tw-text-[#787878]'
            ]"
          >
            {{ descriptionText }}
          </p>

          <small
            class="d-block tw-my-2 tw-text-lg"
          ><a
            href="javascript:void(0)"
            @click="showDescription = !showDescription"
          >{{ showMoreText }}</a></small>
        </template>

        <!-- Pricing selection -->
        <div
          v-if="['F2', 'F3v1', 'F3v2', 'G'].includes(onboardingVariant)"
          class="tw-mb-4"
        >
          <TreatmentSelect
            v-model="selectedpricing"
            :options="options"
            placeholder="Select option"
            @open="setIsDropdownOpen"
          />
        </div>
        <ul
          v-else
          class="list-unstyled list-inline md:tw-my-0"
        >
          <li
            v-for="pricing in product.availablepricing"
            :key="pricing.pricingid"
            class="md:tw-block md:tw-w-full"
          >
            <input
              :id="pricing.pricingid"
              v-model="selectedpricing"
              :value="pricing.pricingid"
              type="radio"
              :name="product.id"
              @click="setPricing(pricing.pricingid)"
            >
            <label
              :for="pricing.pricingid"
              class="subscription-label tw-text-base lg:tw-text-lg"
              :class="{
                'tw-text-sm md:tw-text-base lg:tw-text-lg': mini,
                'tw-mb-0': onboardingVariant === 'E1',
              }"
            >
              ${{ pricing.price }} - {{ pricing.name }}
            </label>
          </li>
        </ul>
      </div>
    </div>
  </b-card>
  <b-card
    v-else
    no-body
    style="border: 0"
    data-clarity-mask="True"
  >
    <b-row no-gutters>
      <b-col
        cols="auto"
        class="mr-1"
      >
        <b-form-checkbox
          :id="'checkbox-' + product.id"
          v-model="selected"
          name="product-id"
          class="product-reveal-checkbox"
          :value="true"
          :unchecked-value="false"
        >
          <!-- Deselect is here -->
        </b-form-checkbox>
      </b-col>
      <b-col>
        <b-row
          no-gutters
          style="position: relative; background-color: #f8f8f8"
        >
          <b-col
            cols="12"
            lg="4"
          >
            <div class="img-holder">
              <img
                :src="
                  product.image == null
                    ? require('@/assets/images/dashboard/articlebg.png')
                    : product.image
                "
              >
            </div>
          </b-col>
          <b-col
            cols="12"
            lg="8"
            class="px-4 py-4"
          >
            <h3
              class="text-default bold-font"
              style="letter-spacing: 0.01em"
            >
              {{ product.name }}
            </h3>
            <!-- Product description -->
            <p class="mb-0">
              {{ descriptionText }}
            </p>
            <small
              class="d-block mb-3"
            ><a
              href="javascript:void(0)"
              @click="showDescription = !showDescription"
            >{{ showMoreText }}</a></small>

            <!-- Pricing selection -->
            <ul
              class="list-unstyled list-inline"
            >
              <li
                v-for="pricing in product.availablepricing"
                :key="pricing.pricingid"
              >
                <input
                  :id="pricing.pricingid"
                  v-model="selectedpricing"
                  :value="pricing.pricingid"
                  type="radio"
                  :name="product.id"
                  @click="setPricing(pricing.pricingid)"
                >
                <label
                  :for="pricing.pricingid"
                  class="subscription-label"
                >
                  ${{ pricing.price }} - {{ pricing.name }}
                </label>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import CustomCheckbox from '@/components/partials/CustomCheckbox.vue';
import TreatmentSelect from '@/components/onboarding/treatments/TreatmentSelect.vue';

export default {
  components: {
    CustomCheckbox,
    TreatmentSelect
  },
  props: {
    product: {
      type: Object,
    },
    existingPricing: {
      type: String,
      default: null,
    },
    mini: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showDescription: false,
      selectedpricing: '',
      selected: false,
      isDropdownOpen: false
      // firstSet: true,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    options() {
      if (['F2', 'F3v1', 'F3v2', 'G'].includes(this.onboardingVariant)) {
        return this.product.availablepricing.map(pricing => {
          const price = pricing.subscriptiontype === 'Quarterly' ? _.ceil(pricing.price / 3) : pricing.price;
          return {
            text: '$' + price + '/mo. - ' + pricing.name,
            value: pricing.pricingid,
          }
        });
      } else {
        return this.product.availablepricing.map(pricing => ({
          text: '$' + pricing.price + '/mo. - ' + pricing.name,
          value: pricing.pricingid,
        }));
      }
    },
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    showCustomCheckbox() {
      return ['D1', 'D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant);
    },
    isAutoSelected() {
      if (!['1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant)) {
        return false
      }

      return !['DHEA'].includes(this.product.name)
    },
    benefitTag(){
      return ['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant)
        ? this.product?.tag
        : 'HSA/FSA-eligible';
    },
    descriptionText() {
      return this.showDescription
        ? this.product.description
        : this.product.shortdescription;
    },
    descriptionTextList() {
      return this.product.description || []
    },
    showMoreText() {
      return this.showDescription ? 'Show less' : 'Show more';
    },
  },
  watch: {
    selected() {
      // if (!this.firstSet) {
      //   this.firstSet = true;
      //   return;
      // }
      if (this.selected && this.selectedpricing == '') {
        this.selectedpricing = this.product.availablepricing[0].pricingid;
      } else if (!this.selected) {
        this.selectedpricing = '';
      }

      this.$emit(
        'set-selection',
        this.product.id,
        this.selected,
        this.selectedpricing,
        this.product.productselect,
        this.product.productdeselect
      );
    },
    selectedpricing() {
      if (this.selected) {
        this.$emit(
          'update-shipping',
          this.product.id,
          this.selectedpricing,
          this.product.productselect,
          this.product.productdeselect,
          this.product.availablepricing
        );
      }
    },
  },
  async mounted() {
    if (this.existingPricing) {
      this.selectedpricing = this.existingPricing;
    } else {
      this.selectedpricing = this.product.availablepricing[0].pricingid;
    }
    // Auto-select if it's an existing pricing, Estrogen/Progesterone, or DHEA
    if (['1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient?.flow_variant)) {
      if (this.existingPricing || this.isAutoSelected || ['DHEA'].includes(this.product.name)) {
        this.selected = true;
      }
    } else {
      this.selected = true
    }
  },
  methods: {
    setSelected(val) {
      this.selected = val;
      if (!val) {
        this.selectedpricing = '';
      }
    },
    async setPricing(val) {
      if (!this.selected) {
        this.selectedpricing = val;
        this.selected = true;
      } else {
        this.selectedpricing = val;
      }
    },
    setIsDropdownOpen(isOpen) {
      this.isDropdownOpen = isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: absolute;
  top: 10px;
  padding: 5px 10px;
  background: #ff8d40;
  right: 0;
  color: $white;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 10px;
  z-index: 1;
}

.list-inline {
  margin-top: 1.5rem;

  li {
    position: relative;
    width: 50%;
    display: inline-block;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }

    input {
      position: absolute;
      left: -9999px;
    }

    label {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:before {
        content: "";
        display: inline-flex;
        flex: 1 150vw;
        width: 15px;
        height: 15px;
        max-width: 15px;
        border-radius: 15px;
        border: 1px solid $primary;
        margin-right: 10px;

        @include media-breakpoint-up(xxl) {
          width: 15px * $scale-font;
          height: 15px * $scale-font;
          max-width: 15px * $scale-font;
          border-radius: 15px * $scale-font;
          margin-right: 10px * $scale-font;
        }
      }
    }

    input:checked + label {
      &:before {
        background-color: $primary;
      }
    }
  }
}

.img-holder {
  width: 100% !important;
  height: calc(100% - 40px);
  background-color: #EBF5F4;
  margin-right: 0 !important;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

html:not(.redesign) {
  .img-holder {
    @include media-breakpoint-down(md) {
      height: 200px !important;
    }
  }
}

::v-deep .v-select-state-select .vs__dropdown-toggle {
  background-color: transparent !important;
  border: 1px solid #C7C7C7 !important;
  border-radius: 10px !important;
}

::v-deep .v-select-state-select .vs__open-indicator {
  fill: #19191C !important;
  transform: scale(1.25) !important;
}
</style>
